import axios from "axios";

import URL from "../config/api";

// O 5º parâmetro é opcional e não altera os chamadores antigos, que passam no
// máximo 4 argumentos:
//   onError — chamado quando o backend recusa (success: false) ou a requisição
//             falha. Sem ele, a falha continua silenciosa como antes.
//   timeout — teto de espera pela resposta, em ms. Sem ele, o axios espera
//             indefinidamente (o padrão do projeto).
export const profileUpdate = (
  user,
  userComplement,
  callback = () => null,
  parents = undefined,
  { onError = () => null, timeout } = {}
) => {
  const obj = { ...user, complement: userComplement, parent: parents };

  return (dispatch, getState) =>
    axios
      .post(`${URL.api}access/user/update/${user.id}`, obj, {
        headers: { authorization: `Bearer ${getState().user.token}` },
        ...(timeout ? { timeout } : {})
      })
      .then(resp => {
        if (resp.data.success) {
          callback(resp);
        } else {
          // Recusa de negócio: e-mail duplicado, validação do backend etc.
          onError(resp.data.error || resp.data.message || null);
        }
      })
      .catch(err => {
        // Rede fora, 5xx ou timeout estourado. Antes virava unhandled rejection.
        onError(
          err.code === "ECONNABORTED"
            ? "O servidor demorou demais para responder"
            : null
        );
      });
};
export const profileGet =
  (id, token, callback = () => null) =>
  (dispatch, getState) => {
    if (id) {
      axios
        .get(`${URL.api}access/user/singleView/${id}`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            const user = resp.data.data;
            dispatch({ type: "GET_PROFILE", payload: user });
            callback(user);
          }
        });
    }
  };
export const profileCreate = (user, token) => (dispatch, getState) => {
  axios
    .post(`${URL.api}access/user/insert`, user, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(resp => {
      // if(resp.data.success){
      //     const user = resp.data.data
      //     return (dispatch({type: 'GET_PROFILE', payload: user}))
      // }
    });
};
export const clearProfile = (id, token) => (dispatch, getState) =>
  dispatch({ type: "GET_PROFILE", payload: "" });
